import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = checking, null = guest
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTab, setModalTab] = useState("login");

  const openAuth = (tab = "login") => {
    setModalTab(tab);
    setModalOpen(true);
  };

  useEffect(() => {
    let active = true;
    api.get("/auth/me")
      .then((res) => active && setUser(res.data))
      .catch(async (e) => {
        if (e.response?.status === 401) {
          try {
            await api.post("/auth/refresh");
            const res = await api.get("/auth/me");
            if (active) setUser(res.data);
            return;
          } catch { /* session over */ }
        }
        if (active) setUser(null);
      });
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      setModalOpen(false);
      return null;
    } catch (e) {
      return formatApiErrorDetail(e.response?.data?.detail);
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      setUser(data);
      setModalOpen(false);
      return null;
    } catch (e) {
      return formatApiErrorDetail(e.response?.data?.detail);
    }
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, modalOpen, openAuth, closeAuth: () => setModalOpen(false), modalTab, setModalTab }}>
      {children}
    </AuthContext.Provider>
  );
};